export default __webpack_public_path__ + "static/media/tete75.51eb5740.png";